import {
    request
} from '../lib/http_request'
import {
    apis
} from '../lib/apis'

// 读取当前数据
const getReadData = obj => new Promise((resolve, reject) => {
    const {
        tableName,
        token
    } = obj;
    request({
        url: apis.conf_read_data + '?tableName=' + tableName + '&token=' + token,
    }).then(res => {
        resolve(res);
    })
});

// 修改业务参数
const modifyBusinessConfiguration = obj => new Promise((resolve, reject) => {
    const {
        businessBO,
        token
    } = obj;
    request({
        url: apis.conf_modify_business_configuration + '?token=' + token,
        data: businessBO
    }).then(res => {
        resolve(res);
    })
});

// 查询配置表以及最新更新时间
const selectShowTables = token => new Promise((resolve, reject) => {
    request({
        url: apis.conf_select_show_tables + '?token=' + token,
    }).then(res => {
        resolve(res);
    })
});

const functionSwitch = obj => new Promise((resolve, reject) => {
    const {
        functionSwitchBO,
        token
    } = obj;
    request({
        url: apis.conf_function_switch + '?token=' + token,
        data: functionSwitchBO
    }).then(res => {
        resolve(res);
    })
});

export default {
    getReadData,
    modifyBusinessConfiguration,
    selectShowTables,
    functionSwitch
}



// WEBPACK FOOTER //
// ./src/service/conf_api.js